export enum CorporateGroupTypeEnum {
  ANNUAL = 'ANNUAL',
  KRUNGSRI = 'KRUNGSRI',
  NORMAL = 'NORMAL',
}
